import { SoftcatApiCatalogue } from 'softcat:types/softcat-api.ts';

const findSoonestWidgetExpiry = (catalogue?: SoftcatApiCatalogue) => {
    if (!catalogue || !catalogue?.packages) {
        return '';
    }

    const expiryDates = catalogue.packages
        .map((cataloguePackage) => {
            const expiryDate = cataloguePackage.widget?.publisherNotAfter || '';
            const date = new Date(expiryDate);

            return Number.isNaN(date.getTime()) ? undefined : date.getTime();
        })
        .filter(Boolean);

    return expiryDates.length > 0 ? new Date(Math.min(...(expiryDates as number[]))).toString() : '';
};

export const CatalogueUtils = {
    findSoonestWidgetExpiry,
};
